var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPrePostConditions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sync_alt_black_48dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5878",
    "data-name": "Group 5878"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 20,
    height: 20,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5880",
    "data-name": "Group 5880",
    transform: "translate(-2.495 -2.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5879",
    "data-name": "Group 5879",
    transform: "translate(3.2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M21.592,6.65,17.907,4V6H5.391C4.626,6,4,6.45,4,7H4c0,.55.626,1,1.391,1H17.907v2l3.685-2.65A.408.408,0,0,0,21.592,6.65Z",
    transform: "translate(-3.2 -4)",
    fill: "#1648c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M19.607,12H7.093V10L3.409,12.65a.406.406,0,0,0,0,.71L7.093,16V14H19.607c.765,0,1.39-.45,1.39-1h0C21,12.45,20.372,12,19.607,12Z",
    transform: "translate(-3.2 0.412)",
    fill: "#1648c6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPrePostConditions);
export default __webpack_public_path__ + "static/media/show-pre-post-conditions.a5f9725e389d5320c115674574d0c7fa.svg";
export { ForwardRef as ReactComponent };